<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>KSeF - sprzedawcy</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>KSeF - sprzedawcy</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>KSeF - sprzedawcy</h5>
            <span class="ibox-toggle" @click="isMainOpen = !isMainOpen">
              <i :class="chevronMainClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <router-link v-if="canAddCompany" to="/ksef/companies/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="control-label">Wpisz liczbę wierszy:</label>
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :loading="loading"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                  <template #item-name="item">
                    <router-link :to="`/ksef/companies/${item.pk}`">
                      {{ item.name }}
                    </router-link>
                  </template>
                  <template #item-is_connection_active="item">
                    {{ item.is_connection_active ? "Tak" : "Nie" }}
                  </template>
                  <template #item-actions="item">
                    <router-link :to="`/ksef/companies/${item.pk}`">
                      <button class="btn btn-primary btn-xs" title="Szczegóły">
                        <i class="fa fa-eye"></i>
                      </button>
                    </router-link>
                    <router-link
                      v-if="canUpdateCompany"
                      :to="`/ksef/companies/${item.pk}/update`"
                    >
                      <button
                        class="btn btn-primary btn-xs ml-5"
                        title="Edytuj"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                    </router-link>
                  </template>
                </EasyDataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import { hasPermission } from "../../permissions";
import { ksefCompanyPermissionsConst } from "../../constants/ksefConstants";

export default {
  name: "KsefCompaniesList",
  components: {
    EasyDataTable,
  },
  setup() {
    const store = useStore();
    const loading = ref(false);
    const items = ref([]);
    const itemsAll = ref(0);
    const rowsPerPage = ref(25);
    const isSearch = ref(false);
    const searchValue = ref({});
    const isMainOpen = ref(true);

    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
      sortBy: "name",
      sortType: "asc",
    });

    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const canAddCompany = computed(() =>
      hasPermission(ksefCompanyPermissionsConst.add)
    );
    const canUpdateCompany = computed(() =>
      hasPermission(ksefCompanyPermissionsConst.update)
    );

    const headers = [
      { text: "Nazwa", value: "name", sortable: true, search: true },
      { text: "NIP", value: "nip", sortable: true, search: true },
      {
        text: "Połączono z KSeF",
        value: "is_connection_active",
        sortable: false,
      },
      { text: "Akcje", value: "actions" },
    ];

    const ksefCompaniesData = computed(
      () => store.getters.getKsefCompaniesData
    );

    const getCompanies = () => {
      loading.value = true;
      store.dispatch("getKsefCompanies", {
        page: serverOptions.value.page,
        page_size: serverOptions.value.rowsPerPage,
        ordering:
          (serverOptions.value.sortType === "desc" ? "-" : "") +
          serverOptions.value.sortBy,
        name: searchValue.value.name || null,
        nip: searchValue.value.nip || null,
      });
    };

    const search = () => {
      isSearch.value = true;
      serverOptions.value.page = 1;
      setTimeout(() => {
        getCompanies();
        isSearch.value = false;
      }, 1000);
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = parseInt(rowsPerPage.value);
      serverOptions.value.page = 1;
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const resetFilters = () => {
      searchValue.value = {};
      serverOptions.value.page = 1;
      serverOptions.value.sortBy = "name";
      serverOptions.value.sortType = "asc";
      getCompanies();
    };

    const updateSort = () => {
      isSearch.value = false;
    };

    watch(
      () => ksefCompaniesData.value,
      function (newValue) {
        if (newValue && newValue.status === 200) {
          itemsAll.value = newValue.data.count;
          items.value = newValue.data.results || [];
        }
        loading.value = false;
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getCompanies();
        }
      },
      { deep: true }
    );

    onMounted(() => {
      getCompanies();
    });

    return {
      loading,
      items,
      itemsAll,
      rowsPerPage,
      isSearch,
      searchValue,
      serverOptions,
      headers,
      search,
      setRowsPerPage,
      selectPage,
      resetFilters,
      updateSort,
      isMainOpen,
      chevronMainClass,
      canAddCompany,
      canUpdateCompany,
    };
  },
};
</script>

<style scoped>
.ibox-title {
  position: relative;
}
.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 12px;
  cursor: pointer;
}
.ml-5 {
  margin-left: 5px;
}
</style>
